import { Settings } from "../Context/SettingsContext";
import { UserLogin } from "./models";

class StorageService {
    getToken = () => this.getProfile()?.token;
    getProfile = () => {
        const settingStr = localStorage.getItem("profile");

        if (settingStr) {
            const profile: UserLogin = JSON.parse(settingStr);
            return profile;
        }
    };

    setProfile = (profile: UserLogin) => localStorage.setItem("profile", JSON.stringify(profile));
    clearToken = () => {
        localStorage.removeItem("profile");
        window.dispatchEvent(new Event("authTokenCleared"));
    };
    getDefaultSettings = () => {
        const settingStr = localStorage.getItem("defaultSettings");

        if (settingStr) {
            const chatSettings: Settings = JSON.parse(settingStr);
            return chatSettings;
        }
    };
    setDefaultSettings = (chatSettings: Settings) => localStorage.setItem("defaultSettings", JSON.stringify(chatSettings));
}

export const storageService = new StorageService();
